import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { styled } from "@mui/material/styles";
import { clearAllFilters } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import { resetAllFilters } from "components/features/AboveProperty/AboveProperty.slice";
import { isFunction } from "lodash";
import React, { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";
import { tokens } from "styles/Tokens";
import Typography from "./Typography";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  sx?: {};
}

const TabPanel = styled((props: TabPanelProps) => {
  const { children, value, index, sx, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
})<TabPanelProps>({});

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  };
}

export default function Basictabs(props: any) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { isMobileScreen } = useContext(ThemeContext);
  const dispatch = useAppDispatch();

  const getDefaultTab = () => {
    if (searchParams.get("parentTab")) {
      let index1 = tabDetails.findIndex((obj: any) => obj.label === searchParams.get("parentTab"));
      if (index1 >= 0) return index1;
      else if (searchParams.get("childTab"))
        return tabDetails.findIndex((obj: any) => obj.label === searchParams.get("childTab"));
      else return props.defaultTab || 0;
    } else return props.defaultTab || 0;
  };

  const {
    tabDetails,
    alignItems = "center",
    selectedTab,
    defaultTab = getDefaultTab(),
    labelVariant = "body1",
    whiteVariant = false,
    gap = "40px",
    backgroundColor,
    marginBottom,
    sx,
    isParentTab = false,
    isChildTab = false,
    getCurrentTab,
    divId = "",
    onTabChangeFn = Function
  } = props;

  const [value, setValue] = React.useState(defaultTab);

  useEffect(() => {
    if (searchParams.get("parentTab")) {
      let index1 = tabDetails.findIndex((obj: any) => obj.label === searchParams.get("parentTab"));
      if (index1 >= 0) {
        setValue(index1);
        return;
      } else if (searchParams.get("childTab")) {
        setValue(tabDetails.findIndex((obj: any) => obj.label === searchParams.get("childTab")));
        return;
      }
    } else setValue(defaultTab);
  }, [selectedTab, defaultTab]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (onTabChangeFn) dispatch(onTabChangeFn());
    setValue(newValue);
    if (isFunction(selectedTab)) selectedTab(newValue);
    dispatch(clearAllFilters());
    dispatch(resetAllFilters());
  };

  useEffect(() => {
    if (getCurrentTab) {
      getCurrentTab(value);
    }
    if (isParentTab && searchParams.get("parentTab") !== tabDetails[value]?.label)
      setSearchParams(
        searchParams.get("childTab") && value === 0
          ? { parentTab: tabDetails[value]?.label, childTab: searchParams.get("childTab") ?? "" }
          : { parentTab: tabDetails[value]?.label }
      );
    if (isChildTab)
      setSearchParams({
        parentTab: searchParams.get("parentTab") ?? "",
        childTab: tabDetails[value]?.label
      });
  }, [value]);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: backgroundColor ?? tokens.Background.General.Secondary,
        alignItems: "center",
        borderRadius: isChildTab ? "12px" : 0
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          width: "100%",
          display: "flex",
          justifyContent: alignItems,
          paddingX: alignItems ? 0 : "20px",
          marginBottom: marginBottom || (isMobileScreen ? 3 : "32px")
        }}
      >
        <Tabs
          textColor={whiteVariant ? "secondary" : "primary"}
          TabIndicatorProps={whiteVariant ? { style: { background: "white" } } : {}}
          sx={{
            ".MuiTabs-flexContainer": { gap: isMobileScreen ? "16px" : gap, ...sx },
            px: isChildTab ? "24px" : 0
          }}
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabDetails?.map((element: any, index: number) => {
            return (
              <Tab
                disableRipple
                sx={{
                  width: "fit-content",
                  minWidth: "auto",
                  paddingX: "0"
                }}
                key={element.label}
                disabled={element.isDisabled}
                label={
                  <Box display={"flex"} flexDirection={"row"} gap={"8px"}>
                    <Typography showBold variant={labelVariant}>
                      {element.label}
                    </Typography>
                    {element.badge ? element.badge : <></>}
                  </Box>
                }
                {...a11yProps(index)}
              />
            );
          })}
        </Tabs>
      </Box>
      {divId ? (
        <Box id={divId} sx={{ ...sx }}>
          {tabDetails?.map((element: any, index: number) => {
            return (
              <TabPanel key={element.label} value={value} index={index} sx={{ width: "100%" }}>
                <element.content></element.content>
              </TabPanel>
            );
          })}
        </Box>
      ) : (
        <>
          {tabDetails?.map((element: any, index: number) => {
            return (
              <TabPanel key={element.label} value={value} index={index} sx={{ width: "100%" }}>
                <element.content></element.content>
              </TabPanel>
            );
          })}
        </>
      )}
    </Box>
  );
}
